module.exports = __webpack_public_path__ + "img/x2.af9073cb.png";